import React from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import useLightBoxStore from 'Store/lightBoxStore'
import Button from '@mui/material/Button'
import DownloadIcon from '@mui/icons-material/Download'
import { useNavigate, useLocation } from 'react-router-dom'

interface Props {}
const ImageLightBox: React.FC<Props> = () => {
      const { isOpen, images, index, closeLightBox, prev, next } = useLightBoxStore()
      const navigate = useNavigate()
      const location = useLocation()

      // Push temp state when Lightbox opens
      React.useEffect(() => {
            if (isOpen) {
                  navigate(location.pathname, { state: { lightbox: true }, replace: false })
            }
      }, [isOpen])

      const handleDownload = () => {
            const link = document.createElement('a')
            link.href = images[index].urls.full
            const video = images[index]?.mime?.startsWith('video/')
            const fileType = video ? 'mp4' : 'jpg'
            link.download = `${images[index].name}.${fileType}`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
      }
      // Listen for back nav to close lightbox
      React.useEffect(() => {
            const unlisten = window.addEventListener('popstate', () => {
                  if (isOpen) {
                        closeLightBox()
                  }
            })

            return () => {
                  window.removeEventListener('popstate', unlisten)
            }
      }, [isOpen])

      const isVideo = images[index]?.mime?.startsWith('video/')
      return (
            <div>
                  {isOpen && images[index]?.urls?.full && (
                        <>
                              <Lightbox
                                    mainSrc={images[index].urls.full}
                                    nextSrc={images[(index + 1) % images.length].urls.full}
                                    prevSrc={
                                          images[(index + images.length - 1) % images.length].urls
                                                .full
                                    }
                                    onCloseRequest={closeLightBox}
                                    onMovePrevRequest={prev}
                                    onMoveNextRequest={next}
                                    imageTitle={images[index].name}
                                    imageCaption={images[index].author ?? ''}
                                    imageLoadErrorMessage={
                                          isVideo ? (
                                                <video
                                                      controls
                                                      autoPlay
                                                      style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain',
                                                            padding: '50px 0',
                                                      }}
                                                >
                                                      <source
                                                            src={images[index].urls.full}
                                                            type="video/mp4"
                                                      />
                                                      Your browser does not support the video tag.
                                                </video>
                                          ) : (
                                                'Error loading image'
                                          )
                                    }
                                    toolbarButtons={[
                                          <Button
                                                key="download-btn"
                                                variant="text"
                                                onClick={handleDownload}
                                          >
                                                <DownloadIcon />
                                          </Button>,
                                    ]}
                              />
                        </>
                  )}
            </div>
      )
}

export default ImageLightBox
